import { Routes } from 'constants/pages';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { WatchedShipment } from 'services/clients/watchList';
import { Cell } from './Cell';
import { CellProps } from './types';

export const ContainerCell: React.FC<CellProps> = (props) => {
  const watch: WatchedShipment = props.row;
  const { containerNumber } = watch;
  const queryParams: Record<string, string | null> = {
    focusedContainer: containerNumber,
  };
  let routeBase = Routes.ShipmentsActive;
  if (watch.trackingStatus === 'ARCHIVED') {
    queryParams.unwatchedState = 'watchedAndUnwatched';
  } else if (watch.trackingStatus === 'DELETED') {
    routeBase = Routes.ShipmentsDeleted;
  }

  const to = `${routeBase}?${Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join('&')}`;
  return (
    <Cell>
      {watch.containerNumber ? (
        <Link to={to} className="text-blue underline">
          {watch.containerNumber}
        </Link>
      ) : (
        '-'
      )}
    </Cell>
  );
};
ContainerCell.displayName = 'AddContainers.RecentlyAdded.Table.ContainerCell';
